import { useState } from "react";

import { Button } from "@monorepo-apps/ui/src/components/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@monorepo-apps/ui/src/components/dialog";

import { useUpsertCriterion } from "@/application/use-cases/products/use-criteria.mutations";
import {
  CriterionFormBody,
  type CriterionFormValues,
} from "@/presentation/components/criteria/criterion-form-body";

interface CreateCriterionDialogProps {
  open: boolean;
  onClose: () => void;
}

export function CreateCriterionDialog({ open, onClose }: CreateCriterionDialogProps) {
  const [values, setValues] = useState<CriterionFormValues | null>(null);
  const upsert = useUpsertCriterion();

  const handleSave = () => {
    if (!values || !values.slug || !values.name) return;
    upsert.mutate(values, {
      onSuccess: () => onClose(),
    });
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="!max-w-2xl">
        <DialogHeader>
          <DialogTitle>New criterion</DialogTitle>
        </DialogHeader>
        <CriterionFormBody initial={null} onChange={setValues} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={upsert.isPending || !values?.slug || !values?.name}
          >
            {upsert.isPending ? "Creating…" : "Create"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
